import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

const StudentAdministrativeInfo = ({ student }) => {
  const isConvenio = student.category === 'convenio';
  const isLicitacion = student.category === 'licitacion';
  const getCategoryInfo = () => {
    if (isConvenio) {
      return student.agreement;
    } else if (isLicitacion) {
      return student.bid;
    }
  };

  return (
    <div>
      <h5>Información administrativa</h5>
      <div className="multiple-fields">
        <div>
          <h6>Ciclo</h6>
          <p>{student.currentGradeInstance.cycleName}</p>
        </div>
        <div>
          <h6>Clase</h6>
          <p>{student.currentGradeInstance.gradeName}</p>
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <h6>Fecha de inscripción</h6>
          <p>{moment(student.admissionDate).format('DD/MM/YYYY')}</p>
        </div>
        <div>
          <h6>Oficina de inscripción</h6>
          <p>{student.inscriptionOffice}</p>
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <h6>Fecha de vencimiento vacunas</h6>
          <p>{moment(student.expirationVaccines).format('DD/MM/YYYY')}</p>
        </div>
        <div>
          <h6>Fecha de vencimiento de aptitud física</h6>
          <p>{moment(student.expirationVaccines).format('DD/MM/YYYY')}</p>
        </div>
      </div>
      <div className={!isConvenio && !isLicitacion ? 'single-field' : 'multiple-fields'}>
        <div>
          <h6>Categoria</h6>
          <p>{_.capitalize(student.category)}</p>
        </div>
        { isConvenio &&
          <div>
            <h6>Convenio</h6>
            <p>{getCategoryInfo().name}</p>
          </div>
        }
        { isLicitacion &&
          <div>
            <h6>Licitación</h6>
            <p>{getCategoryInfo().name}</p>
          </div>
        }
      </div>
    </div>
  );
};

const { object } = PropTypes;

StudentAdministrativeInfo.propTypes = {
  student: object.isRequired
};

export default StudentAdministrativeInfo;



// WEBPACK FOOTER //
// ./src/components/student/StudentAdministrativeInfo.js